import React, { FC, ReactNode } from "react";
import { Dialog } from "@headlessui/react";
import { XIcon } from "@heroicons/react/outline";
import cn from "clsx";

type Props = Readonly<{
  open: boolean;
  toggleModal: (v: boolean) => void;
  noBackground?: boolean;
  _size?: "wide" | "thin" | "medium" | "extra-large";
  children: ReactNode | undefined;
}>;

export const Modal: FC<Props> = ({
  open,
  toggleModal,
  noBackground = false,
  _size = "thin",
  children,
}) => {
  return (
    <Dialog
      as="div"
      className="fixed z-2000 inset-0 overflow-y-auto"
      onClose={toggleModal}
      open={open}
    >
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        {/* This element is to trick the browser into centering the modal contents. */}
        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className={cn(
            "inline-block align-bottom text-left transform transition-all md:p-6 sm:align-middle rounded-[10px] overflow-hidden",

            {
              "bg-white": !noBackground,
            }
          )}
        >
          <button
            className="absolute top-2 right-2"
            type="button"
            onClick={() => toggleModal(false)}
          >
            <XIcon className="duration-150 font-bold w-6 h-6 text-black-inactive hover:text-high-contrast" />
          </button>

          {children}
        </div>
      </div>
    </Dialog>
  );
};
